import React from 'react'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FlexRow, FlexAlign } from 'src/components/Reusable/Flex'
import { Spinner } from 'src/Throbber'
import { IconButton, IconButtonVariant } from '../IconButton'

interface ConfirmCancelButtonsProps {
  onConfirm: (e: React.MouseEvent) => void
  onCancel: (e: React.MouseEvent) => void
  // A spinner takes the check's place, and both buttons are disabled.
  isSaving?: boolean
  confirmLabel?: string
  cancelLabel?: string
  justify?: FlexAlign
  style?: React.CSSProperties
}

// The check and cross that save or cancel an inline edit.
export const ConfirmCancelButtons = ({
  onConfirm,
  onCancel,
  isSaving = false,
  confirmLabel = 'Save',
  cancelLabel = 'Cancel',
  justify = FlexAlign.FLEX_END,
  style,
}: ConfirmCancelButtonsProps): JSX.Element => (
  <FlexRow gap={8} justify={justify} style={style}>
    <IconButton
      onClick={onConfirm}
      disabled={isSaving}
      aria-busy={isSaving}
      title={confirmLabel}
      aria-label={confirmLabel}
      type="button"
      variant={IconButtonVariant.icon}
    >
      {isSaving ? (
        <Spinner size="s" color="primary" />
      ) : (
        <FontAwesomeIcon icon={faCheck} />
      )}
    </IconButton>
    <IconButton
      onClick={(e) => {
        e.stopPropagation()
        onCancel(e)
      }}
      disabled={isSaving}
      title={cancelLabel}
      aria-label={cancelLabel}
      type="button"
      variant={IconButtonVariant.icon}
    >
      <FontAwesomeIcon icon={faTimes} />
    </IconButton>
  </FlexRow>
)
